module.exports = __webpack_public_path__ + "img/s7Model1M.9f6095ae.webp";